import React from "react";
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ElectricMeterIcon from '@mui/icons-material/ElectricMeter';
import SpeedIcon from '@mui/icons-material/Speed';
import WifiIcon from '@mui/icons-material/Wifi';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import PowerIcon from '@mui/icons-material/Power';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import WindPowerIcon from '@mui/icons-material/WindPower';
import ComputerIcon from '@mui/icons-material/Computer';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import RouterIcon from '@mui/icons-material/Router';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import { Sonde } from "components/CustomIcon/CustomIcon";
import { Vanne } from "components/CustomIcon/CustomIcon";
import { Thermostat } from "components/CustomIcon/CustomIcon";
import { Thermostat2 } from "components/CustomIcon/CustomIcon";
import { Badgeuse } from "components/CustomIcon/CustomIcon";
import { Pompe } from "components/CustomIcon/CustomIcon";
import { V2V } from "components/CustomIcon/CustomIcon";


export const plan2ddefaultviewData = [
    { name: "Aucune", id: "none" },
    { name: "IoT", id: "iot" },
    { name: "Equipements", id: "eq" },
    { name: "Data", id: "data" },
    // { name: "Liste des équipements", id: "equipments" },
]

export const viewmenuData = [
    { name: "Dashboard", id: "dashboard" },
    { name: "Pilotage", id: "control" },
    { name: "Equipements", id: "equipments" },
]

export const valuetypeData = [
    { name: "Point de donnée", id: "point" },
    { name: "Aggrégation des enfants", id: "agg" },
    // { name: "Formule", id: "formula" },
]

export const aggchildrenData = [
    { name: "Somme", id: "sum" },
    { name: "Moyenne", id: "avg" },
    { name: "Maxmimum", id: "max" },
    { name: "Minimum", id: "min" },
]

export const locationtypeData = [
    { name: "Emplacement libre", id: "freelocation" },
    { name: "Entitée dans l'arbre", id: "entity" },
]


export const planitemiconData = [
    { name: "Electricité", id: "electricbolt", icon: ElectricBoltIcon },
    { name: "Eclairage", id: "lightbulb", icon: LightbulbIcon },
    { name: "Compteur électrique", id: "electricmeter", icon: ElectricMeterIcon },
    { name: "Prise de courant", id: "power", icon: PowerIcon },
    { name: "Wifi", id: "wifi", icon: WifiIcon },
    { name: "Climatisation", id: "acunit", icon: AcUnitIcon },
    { name: "Ventilation", id: "windpower", icon: WindPowerIcon },
    { name: "Informatique", id: "computer", icon: ComputerIcon },
    { name: "Chauffage", id: "heat", icon: LocalFireDepartmentIcon },
    { name: "Passerelle", id: "box", icon: RouterIcon },
    { name: "Sonde IoT", id: "iotdevice", icon: SettingsRemoteIcon },
    { name: "Sonde ambiance IoT", id: "iotsensor", icon: Sonde },
    { name: "Vanne thermostatique", id: "iotvalve", icon: Vanne },
    // { name: "Thermostat", id: "thermostat", icon: Thermostat },
    { name: "Thermostat2", id: "thermostat2", icon: Thermostat2 },
    { name: "Badgeuse", id: "thermostat2", icon: Badgeuse },
    { name: "Pompe", id: "pump", icon: Pompe },
    { name: "V2V", id: "v2v", icon: V2V },
]

export const item2dlayerData = [
    { name: "Valeur", id: "data" },
    { name: "Objet communicant", id: "iot" },
    { name: "Equipement", id: "equipments" },
    { name: "AVOB Box", id: "avobbox" },
    { name: "Passerelle LoRaWAN", id: "lorawanbox" },
    { name: "Lien vers un plan", id: "link" },
]

export const item2diconsizeData = [
    { name: "Petite", id: "small" },
    { name: "Moyenne", id: "average" },
    { name: "Grande", id: "big" },
]

export const item2dtextsizeData = [
    { name: "Petit", id: "small" },
    { name: "Moyen", id: "average" },
    { name: "Grand", id: "big" },
]

export const item2dvaluetypeData = [
    { name: "Point de donnée", id: "point" },
]

export const item2dstepcolorData = [
    { name: "Sans couleur", id: "nocolor" },
    { name: "Vert", id: "green" },
    { name: "Bleu", id: "blue" },
    { name: "Orange", id: "orange" },
    { name: "Rouge", id: "red" },
    { name: "Jaune", id: "yellow" },
    { name: "Violet", id: "purple" },
]

export const item2dpointaggData = [
    { name: "Donnée brute", id: "raw" },
    { name: "Donnée aggrégée horaire", id: "hour" },
    { name: "Donnée aggrégée journalière", id: "day" },
]

export const automationtypeData = [
    { name: "Dérogation de consigne", id: "derogation" },
    { name: "Règle de pilotage", id: "controlrule" },
]

export const triggertypeData = [
    { name: "QR Code", id: "qrcode" },
    { name: "Badge RFID", id: "badge" },
]